"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var FolderListModal_1 = __importDefault(require("../DocumentLibraryComponent/FolderListModal"));
var ListFolders_1 = __importDefault(require("../DocumentLibraryComponent/ListFolders"));
var DocumentLibraryService_1 = __importDefault(require("../../../Trillium.UI/TypeScript/Services/DocumentLibrary/DocumentLibraryService"));
var SearchBox_1 = __importDefault(require("../DocumentLibraryComponent/SearchBox"));
var moment_1 = __importDefault(require("moment"));
var service = new DocumentLibraryService_1.default();
var maxFileUploadSize = 10000000;
var EvidenceUploadComponent = function (props) {
    var EvidencesToUpload = props.EvidencesToUpload ? props.EvidencesToUpload : 1;
    var _a = react_1.useState(null), anchorEl = _a[0], setAnchorEl = _a[1];
    var open = Boolean(anchorEl);
    var _b = react_1.useState([]), listOfFolders = _b[0], setListOfFolders = _b[1];
    var _c = react_1.useState({ open: false, folder: null }), folderDetails = _c[0], setFolderDetails = _c[1];
    var _d = react_1.useState({ open: false }), fileUploadDialog = _d[0], setFileUploadDialog = _d[1];
    var _e = react_1.useState(null), file = _e[0], setFile = _e[1];
    var _f = react_1.useState({ open: false }), existingDialog = _f[0], setexistingDialog = _f[1];
    var _g = react_1.useState(""), serchTerm = _g[0], setSerchterm = _g[1];
    var _h = react_1.useState([]), documentList = _h[0], setDocumentList = _h[1];
    var _j = react_1.useState('NameAscending'), sortValue = _j[0], setSortValue = _j[1];
    var _k = react_1.useState(props.EvidenceAttachmentDetails), uploadedFile = _k[0], setUploadedFile = _k[1];
    var _l = react_1.useState(EvidencesToUpload), uploadCount = _l[0], setUploadCount = _l[1];
    var _m = react_1.useState(""), evidenceAttachmentValue = _m[0], setEvidenceAttachmentValue = _m[1];
    var IsEvidenceRequired = props.IsEvidenceRequired ? props.IsEvidenceRequired : false;
    react_1.useEffect(function () {
        var _a, _b, _c;
        getFolderList();
        if (props.EvidenceAttachmentDetails != null) {
            setEvidenceAttachmentValue((_b = (_a = props.EvidenceAttachmentDetails) === null || _a === void 0 ? void 0 : _a.map(function (x) { return x.Id; })) === null || _b === void 0 ? void 0 : _b.join(","));
            setUploadedFile(props.EvidenceAttachmentDetails);
            setUploadCount(EvidencesToUpload - ((_c = props.EvidenceAttachmentDetails) === null || _c === void 0 ? void 0 : _c.length));
        }
    }, []);
    var onsort = function (value) {
        setSortValue(value);
        var sortDoc = __spreadArrays(documentList);
        var sortFol = __spreadArrays(listOfFolders);
        switch (value) {
            case 'dateRecent':
                sortDoc = documentList.sort(function (a, b) { return new Date(b.Modified).getTime() - new Date(a.Modified).getTime(); });
                sortFol = listOfFolders.sort(function (a, b) { return new Date(b.Modified).getTime() - new Date(a.Modified).getTime(); });
                break;
            case 'dateOldest':
                sortDoc = documentList.sort(function (a, b) { return new Date(a.Modified).getTime() - new Date(b.Modified).getTime(); });
                sortFol = listOfFolders.sort(function (a, b) { return new Date(a.Modified).getTime() - new Date(b.Modified).getTime(); });
                break;
            case 'NameAscending':
                sortDoc = documentList.sort(function (a, b) { return a.Name.toLowerCase().localeCompare(b.Name.toLowerCase()); });
                sortFol = listOfFolders.sort(function (a, b) { return a.Name.toLowerCase().localeCompare(b.Name.toLowerCase()); });
                break;
            case 'NameDescending':
                sortDoc = documentList.sort(function (a, b) { return b.Name.toLowerCase().localeCompare(a.Name.toLowerCase()); });
                sortFol = listOfFolders.sort(function (a, b) { return b.Name.toLowerCase().localeCompare(a.Name.toLowerCase()); });
                break;
            default:
                break;
        }
        setDocumentList(sortDoc);
        setListOfFolders(sortFol);
    };
    var getFolderList = function (name) {
        if (name === void 0) { name = ""; }
        return __awaiter(void 0, void 0, void 0, function () {
            var response, res, sortFol;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, service.getFolderWithRelatedItems(props.MembershipNumber, name)];
                    case 1:
                        response = _a.sent();
                        res = response.Result;
                        sortFol = res.sort(function (a, b) { return a.Name.toLowerCase().localeCompare(b.Name.toLowerCase()); });
                        setListOfFolders(sortFol);
                        return [2 /*return*/];
                }
            });
        });
    };
    var handleNewFileUpload = function (e) {
        var newFiles = e.target.files;
        if (newFiles.length && newFiles[0].size <= maxFileUploadSize) {
            setFile(newFiles[0]);
        }
    };
    var dataFile = function (file) { return new Promise(function (resolve, rejects) {
        var reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = function () { return resolve(reader.result); };
        reader.onerror = function (e) { return rejects(e); };
    }); };
    var onUploadFile = function () { return __awaiter(void 0, void 0, void 0, function () {
        var fileUploaded, bufferArray, bufferFile, fileByteArray, _i, bufferFile_1, a, uploadDate_1, i, res, response, fileData, splitName, newName;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    fileUploaded = false;
                    if (!file) return [3 /*break*/, 8];
                    return [4 /*yield*/, dataFile(file)];
                case 1:
                    bufferArray = _a.sent();
                    bufferFile = new Uint8Array(bufferArray);
                    fileByteArray = [];
                    for (_i = 0, bufferFile_1 = bufferFile; _i < bufferFile_1.length; _i++) {
                        a = bufferFile_1[_i];
                        fileByteArray.push(a);
                    }
                    uploadDate_1 = {
                        folderUrl: folderDetails.folder.Url,
                        folderName: folderDetails.folder.Name,
                        fileName: file.name,
                        fileContent: fileByteArray,
                    };
                    i = 1;
                    _a.label = 2;
                case 2:
                    if (!(i <= 100)) return [3 /*break*/, 7];
                    return [4 /*yield*/, service.uploadDocumentFile(uploadDate_1)];
                case 3:
                    res = _a.sent();
                    if (!res.Success) return [3 /*break*/, 5];
                    onDialogClose();
                    return [4 /*yield*/, service.getsearchFiles(res.Result.FileName, props.MembershipNumber, true)];
                case 4:
                    response = _a.sent();
                    if (response.Success) {
                        fileData = response.Result.find(function (f) { return f.Url.includes(uploadDate_1.folderUrl + "/" + uploadDate_1.fileName); });
                        handleUploadedDoc(fileData !== null && fileData !== void 0 ? fileData : null);
                        setFile(null);
                        fileUploaded = true;
                    }
                    return [3 /*break*/, 7];
                case 5:
                    splitName = file.name.split(/\.(?=[^\.]+$)/);
                    newName = splitName[0] + ' (' + i + ').' + splitName[1];
                    uploadDate_1.fileName = newName;
                    _a.label = 6;
                case 6:
                    i++;
                    return [3 /*break*/, 2];
                case 7:
                    if (fileUploaded) {
                        getFolderList();
                    }
                    _a.label = 8;
                case 8: return [2 /*return*/];
            }
        });
    }); };
    var onRemoveFile = function () {
        setFile(null);
    };
    var handleClick = function (e) {
        setAnchorEl(e.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var onDialogOpen = function () {
        handleClose();
        setFolderDetails({ open: true });
    };
    var onDialogClose = function () {
        setFileUploadDialog({ open: false });
    };
    var closeFolderDialog = function () {
        setFolderDetails({ open: false, folder: null });
    };
    var onContinueFolder = function () {
        setFolderDetails(__assign(__assign({}, folderDetails), { open: false }));
        setFileUploadDialog({ open: true });
    };
    var onFolderSelect = function (folder) {
        setFolderDetails(__assign(__assign({}, folderDetails), { folder: folder }));
    };
    var onExistingDialogOpen = function () {
        handleClose();
        setexistingDialog({ open: true });
    };
    var onExistingDialogClose = function () {
        setexistingDialog({ open: false });
    };
    var existingDialogContent = function () {
        var onFolderSelect = function (folder) { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setDocumentList([]);
                        return [4 /*yield*/, service.getFolderWithRelatedItems(props.MembershipNumber, folder.Name)];
                    case 1:
                        response = _a.sent();
                        setexistingDialog(__assign(__assign({}, existingDialog), { folder: folder }));
                        if (response.Success)
                            setDocumentList(response.Result);
                        return [2 /*return*/];
                }
            });
        }); };
        var onDocSelect = function (document) {
            setexistingDialog(__assign(__assign({}, existingDialog), { document: document }));
        };
        if ((existingDialog.folder || serchTerm) && documentList.length) {
            return react_1.default.createElement("div", { className: "" },
                react_1.default.createElement("div", { className: "card-body" },
                    react_1.default.createElement("table", { className: "table" },
                        react_1.default.createElement("thead", null,
                            react_1.default.createElement("tr", null,
                                react_1.default.createElement("th", null, "Name"),
                                react_1.default.createElement("th", { className: 'text-right' }, "Last modified"))),
                        react_1.default.createElement("tbody", null, documentList.map(function (d) {
                            var _a;
                            return react_1.default.createElement("tr", { className: 'cp', onClick: function () { return onDocSelect(d); }, style: ((_a = existingDialog.document) === null || _a === void 0 ? void 0 : _a.Id) === d.Id ? { backgroundColor: '#a9a9a9' } : {}, key: d.Id },
                                react_1.default.createElement("td", null, d.Name),
                                react_1.default.createElement("td", { className: 'text-right' }, moment_1.default(d.Modified).fromNow()));
                        })))));
        }
        return react_1.default.createElement(ListFolders_1.default, { HeaderText: "", Folders: listOfFolders === null || listOfFolders === void 0 ? void 0 : listOfFolders.filter(function (x) { return x.Type === 'folder'; }), onFolderclick: onFolderSelect, selectFolder: existingDialog.folder ? existingDialog.folder.Id : "" });
    };
    var backToFolder = function () {
        setexistingDialog(__assign(__assign({}, existingDialog), { document: null, folder: null }));
        setDocumentList([]);
    };
    var onAttachExistingDoc = function () {
        var file = existingDialog.document;
        if (file) {
            handleUploadedDoc(file);
        }
        onExistingDialogClose();
    };
    var handleUploadedDoc = function (file) {
        if (file === null)
            return;
        if (EvidencesToUpload > 1 || EvidencesToUpload === -1) {
            if ((uploadedFile === null || uploadedFile === void 0 ? void 0 : uploadedFile.length) >= 1) {
                setUploadedFile(__spreadArrays(uploadedFile, [__assign({}, file)]));
                if (evidenceAttachmentValue != "") {
                    setEvidenceAttachmentValue(evidenceAttachmentValue + "," + file.Id);
                }
                else {
                    setEvidenceAttachmentValue("" + file.Id);
                }
            }
            else {
                setUploadedFile([__assign({}, file)]);
                setEvidenceAttachmentValue("" + file.Id);
            }
            setUploadCount(uploadCount - 1);
        }
        else {
            setUploadedFile([__assign({}, file)]);
            setEvidenceAttachmentValue("" + file.Id);
            setUploadCount(uploadCount - 1);
        }
    };
    var onserchChange = function (value) {
        if (!serchTerm)
            setDocumentList([]);
        setSerchterm(value);
    };
    var onSerchDoc = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, service.getsearchFiles(serchTerm, props.MembershipNumber, true)];
                case 1:
                    response = _a.sent();
                    if (response.Success) {
                        setDocumentList(response.Result);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var removeAttachFile = function (index) {
        if (evidenceAttachmentValue != "") {
            if ((uploadedFile === null || uploadedFile === void 0 ? void 0 : uploadedFile.length) > 1) {
                var evidenceGuid = evidenceAttachmentValue.split(',');
                if ((evidenceGuid === null || evidenceGuid === void 0 ? void 0 : evidenceGuid.length) > 1) {
                    evidenceGuid.splice(index, 1);
                    setEvidenceAttachmentValue(evidenceGuid.join(','));
                }
            }
            else {
                setEvidenceAttachmentValue("");
            }
        }
        var tempArr = uploadedFile;
        if (uploadCount < EvidencesToUpload - 1) {
            if (index > -1) {
                tempArr.splice(index, 1);
            }
            setUploadedFile(tempArr);
            console.log(tempArr);
        }
        else {
            setUploadedFile(undefined);
        }
        setUploadCount(uploadCount + 1);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        props.AbleToAttachDocument ? react_1.default.createElement(react_1.default.Fragment, null,
            uploadedFile && uploadedFile.length > 0 && uploadedFile.map(function (item, index) {
                var _a;
                return (react_1.default.createElement("div", { key: index, className: 'mb-3' },
                    react_1.default.createElement("span", { className: 'mr-2' }, (_a = item === null || item === void 0 ? void 0 : item.Name) !== null && _a !== void 0 ? _a : "unknown file"),
                    react_1.default.createElement("span", { className: 'remove', onClick: function () { return removeAttachFile(index); } }, props.DictionaryList.IPDAttributesRemoveButtonText)));
            }),
            uploadCount != 0 || EvidencesToUpload === -1 ? react_1.default.createElement("span", { className: "btn btn-primary w-100 p-2", onClick: function (e) { return handleClick(e); }, "aria-controls": open ? 'account-menu' : undefined, "aria-haspopup": "true", "aria-expanded": open ? 'true' : undefined }, props.DictionaryList.IPDAttributesAddDocumentButtonText) : null) : null,
        react_1.default.createElement("input", { type: 'hidden', id: 'EvidenceAttachment', name: 'EvidenceAttachment', value: evidenceAttachmentValue ? "" + evidenceAttachmentValue : "", "aria-invalid": IsEvidenceRequired, "data-val": IsEvidenceRequired, "data-val-required": props.DictionaryList.IPDAnnualAppraisalEvidenceAttachmentRequired }),
        evidenceAttachmentValue === "" ? react_1.default.createElement("div", { className: "field-validation-error text-left", "data-valmsg-for": "EvidenceAttachment", "data-valmsg-replace": "true" }) : null,
        react_1.default.createElement(core_1.Dialog, { open: open, onClose: handleClose, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description", maxWidth: "sm", className: 'ipd-portal' },
            react_1.default.createElement(core_1.DialogContent, { className: 'attach-menu' },
                react_1.default.createElement("div", { className: 'fileUpBtn', onClick: onDialogOpen },
                    react_1.default.createElement("i", { className: "fas fa-cloud-upload-alt menu-icon" }),
                    react_1.default.createElement("span", { dangerouslySetInnerHTML: { __html: props.DictionaryList.IPDAttributesEvidenceAttachFileUploadTitle } })),
                react_1.default.createElement("div", { className: 'fileUpBtn', onClick: onExistingDialogOpen },
                    react_1.default.createElement("i", { className: "pdf-icon fas fa-file-pdf menu-icon" }),
                    react_1.default.createElement("span", { dangerouslySetInnerHTML: { __html: props.DictionaryList.IPDAttributesEvidenceAttachExistingFileTitle } })))),
        react_1.default.createElement(FolderListModal_1.default, { open: folderDetails.open, onClose: closeFolderDialog, onContinue: onContinueFolder, anySelect: folderDetails.folder, cancleButton: props.DictionaryList.IPDAttributesCancelButtonText, moveButton: props.DictionaryList.IPDAttributesNextButtonText },
            react_1.default.createElement(ListFolders_1.default, { HeaderText: props.DictionaryList.IPDAttributesListFolderHeader, Folders: listOfFolders === null || listOfFolders === void 0 ? void 0 : listOfFolders.filter(function (x) { return x.Type === 'folder'; }), onFolderclick: onFolderSelect, selectFolder: folderDetails.folder ? folderDetails.folder.Id : "" })),
        react_1.default.createElement(core_1.Dialog, { open: fileUploadDialog.open, onClose: onDialogClose, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description", maxWidth: "md", className: 'ipd-portal ipd-dialog-file-uploader' },
            react_1.default.createElement(core_1.DialogTitle, { id: "alert-dialog-title", className: 'up-padding' },
                props.DictionaryList.IPDAttributesUploadFileHeader,
                react_1.default.createElement("img", { src: '/images/icons/close.svg', className: 'closeIcon cursor-pointer', onClick: onDialogClose })),
            react_1.default.createElement(core_1.DialogContent, { className: 'file-padding' },
                react_1.default.createElement("div", { className: 'row fileupload' },
                    react_1.default.createElement("div", { className: 'col-md-12 nopadding' },
                        react_1.default.createElement("div", { className: 'fileBox' },
                            react_1.default.createElement("div", { className: 'fileIcon' },
                                react_1.default.createElement("i", { className: "fas fa-cloud-upload-alt" })),
                            react_1.default.createElement("p", null, file ? file.name : react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement("span", null, "Add file"),
                                " or drop file here")),
                            react_1.default.createElement("input", { type: "file", title: "", accept: "image/*,application/pdf", value: "", onChange: function (e) { return handleNewFileUpload(e); } })))),
                react_1.default.createElement("p", { className: 'mb-0 uploadtext', dangerouslySetInnerHTML: { __html: props.DictionaryList.IPDAttributesUploadFileSizeMessage } }),
                react_1.default.createElement("p", { className: 'mb-0 uploadtext', dangerouslySetInnerHTML: { __html: props.DictionaryList.IPDAttributesFileUploadAcceptMessage } })),
            react_1.default.createElement(core_1.DialogActions, null, file ? react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(core_1.Button, { onClick: onRemoveFile, color: "primary", className: 'btn btn-primary btn-primary-outline  mr-auto' }, props.DictionaryList.IPDAttributesRemoveButtonText),
                react_1.default.createElement(core_1.Button, { onClick: onUploadFile, color: "primary", className: 'btn btn-primary' }, props.DictionaryList.IPDAttributesUploadButtonText)) :
                react_1.default.createElement(core_1.Button, { onClick: onDialogClose, color: "primary", className: 'btn btn-primary btn-primary-outline  mr-auto' }, props.DictionaryList.IPDAttributesCancelButtonText))),
        react_1.default.createElement(core_1.Dialog, { onClose: onExistingDialogClose, "aria-labelledby": "simple-dialog-title", open: existingDialog.open, className: 'ipd-portal folder_list', maxWidth: 'lg' },
            react_1.default.createElement(core_1.DialogTitle, { id: "simple-dialog-title" },
                props.DictionaryList.IPDAttributesSelectFolderHeader,
                react_1.default.createElement("img", { src: '/images/icons/close.svg', className: 'closeIcon cursor-pointer', onClick: onExistingDialogClose })),
            react_1.default.createElement(core_1.DialogContent, null,
                react_1.default.createElement(SearchBox_1.default, { SearchTerm: serchTerm, RootFolder: "", PlaceHolder: props.DictionaryList.IPDAttributesDocumentSerchPlaceolder, SearchItems: onSerchDoc, onSerchChange: onserchChange },
                    react_1.default.createElement("select", { value: sortValue, className: 'w-100 order-list', onChange: function (e) { return onsort(e.target.value); } },
                        react_1.default.createElement("option", { value: "NameAscending" }, props.DictionaryList.IPDAttributesNameAscending),
                        react_1.default.createElement("option", { value: "NameDescending" }, props.DictionaryList.IPDAttributesNameDescending),
                        react_1.default.createElement("option", { value: "dateRecent" }, props.DictionaryList.IPDAttributesDateRecent),
                        react_1.default.createElement("option", { value: "dateOldest" }, props.DictionaryList.IPDAttributesDateOldest))),
                existingDialog.folder && react_1.default.createElement("div", { className: 'folder-nav' },
                    react_1.default.createElement("span", { className: 'cp', onClick: backToFolder }, "My Folder > "),
                    existingDialog.folder.Name),
                existingDialogContent()),
            react_1.default.createElement(core_1.DialogActions, null,
                react_1.default.createElement(core_1.Button, { onClick: onExistingDialogClose, className: 'btn btn-primary btn-primary-outline  mr-auto' }, props.DictionaryList.IPDAttributesCancelButtonText),
                existingDialog.document ? react_1.default.createElement(core_1.Button, { onClick: onAttachExistingDoc, className: 'btn btn-primary' }, props.DictionaryList.IPDAttributesAttachDocButtonText) : null))));
};
exports.default = EvidenceUploadComponent;
